import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from 'app/auth/authConfig';

export const msalInstance = new PublicClientApplication(msalConfig);

// Export an `initPromise` that can be awaited where needed
export const msalInitPromise = msalInstance.initialize().then(async () => {
    const redirectResponse = await msalInstance.handleRedirectPromise();
    if (redirectResponse?.account) {
        msalInstance.setActiveAccount(redirectResponse.account);
    } else {
        const cachedAccounts = msalInstance.getAllAccounts();
        if (cachedAccounts.length > 0 && !msalInstance.getActiveAccount()) {
            msalInstance.setActiveAccount(cachedAccounts[0]);
        }
    }
});